import { useState } from 'react';
import styles from './contact.module.css';
import contactBackground from '../assets/contactBack.png';


// WhatsApp Configuration
const WHATSAPP_NUMBER = import.meta.env.VITE_WHATSAPP_NUMBER;

// Available instruments
const INSTRUMENTS = [
  'Drums',
  'Piano',
  'Guitar',
  'Violin',
  'Keyboard',
];


 const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    instrument: '',
    phone: '',
    subject: '',
    message: ''
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

      const number = WHATSAPP_NUMBER || '919080465878'; 

    
    const whatsappMessage = `Hi! I'm *${formData.name}* and I'm interested to learn *${formData.instrument}* at Vibe Musicals. Can you provide further details as follows:

*Phone Number:* ${formData.phone}
*Subject:* ${formData.subject}

*Additional Message:*
${formData.message}

Looking forward to hearing from you!`;

    const encodedMessage = encodeURIComponent(whatsappMessage);
    window.open(`https://wa.me/${number}?text=${encodedMessage}`, '_blank');

    setFormData({
      name: '',
      instrument: '',
      phone: '',
      subject: '',
      message: ''
    });
  };

  return (
    <div id='contact' className={styles.contactPage}>
      <section 
        className={styles.contactSection}
        style={{ backgroundImage: `url(${contactBackground})` }}
      >
        <div className={styles.contactOverlay}></div>
        
        <div className={styles.contactContainer}>
          <div className={`${styles.contactFormWrapper} ${styles['fade-in-left']}`}>
            <h2 className={styles.contactTitle}>CONTACT</h2>
            
            <form className={styles.contactForm} onSubmit={handleSubmit}>
              <input
                type="text"
                name="name"
                placeholder="YOUR NAME"
                className={styles.inputField}
                value={formData.name}
                onChange={handleChange}
                required
              />
              
              <select
                name="instrument"
                className={styles.selectField}
                value={formData.instrument}
                onChange={handleChange}
                required
              >
                <option value="" disabled>SELECT INSTRUMENT</option>
                {INSTRUMENTS.map((instrument, index) => (
                  <option key={index} value={instrument}>
                    {instrument}
                  </option>
                ))}
              </select>
              
              <input
                type="tel"
                name="phone"
                placeholder="PHONE NUMBER"
                className={styles.inputField}
                value={formData.phone}
                onChange={handleChange}
                required
              />
              
              <input
                type="text"
                name="subject"
                placeholder="SUBJECT"
                className={styles.inputField}
                value={formData.subject}
                onChange={handleChange}
                required
              />
              
              <textarea
                name="message"
                placeholder="YOUR MESSAGE"
                className={styles.textareaField}
                value={formData.message}
                onChange={handleChange}
                rows="5"
                required
              ></textarea>
              
              <button type="submit" className={styles.submitBtn}>
                SUBMIT
              </button>
            </form>
          </div>
          
          <div className={`${styles.mapWrapper} ${styles['fade-in-right']}`}>
            <h2 className={styles.mapTitle}>MAP</h2>
            
            <div className={styles.mapContainer}>
              <div className={styles.mapImage}>
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3889.1896759671627!2d80.23328957485305!3d12.895521887412876!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a525bc005616759%3A0x5605f89db81579ce!2sVibe%20musicals!5e0!3m2!1sen!2sin!4v1767907365950!5m2!1sen!2sin"
                  width="100%"
                  height="100%"
                  style={{ border: 0 }}
                  allowFullScreen=""
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  title="Vibe Musicals Location"
                ></iframe>
              </div>
              
              <div className={styles.mapInfo}>
                <h3 className={styles.locationName}>Vibe musicals</h3>
                <div className={styles.rating}>
                  <span className={styles.ratingScore}>4.9</span>
                  <span className={styles.ratingStars}>★★★★★</span>
                  <span className={styles.ratingCount}>(122)</span>
                </div>
                <p className={styles.locationType}>Music school</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};
export default Contact;
